import { createSlice } from '@reduxjs/toolkit';
import api from 'src/api/index';
import i18n from 'src/i18n';
import { showErrorToast } from './toast';

const initialState = {
	list: [],
	draft: null,
	loading: false
};

const meditationsSlice = createSlice({
	name: 'meditations',
	initialState,
	reducers: {
		setMeditationsList: (state, action) => {
			state.list = action.payload;
		},
		addMeditationsItem: (state, action) => {
			state.list.push(action.payload);
		},
		setMeditationDraft: (state, action) => {
			if (state.draft) {
				state.draft = { ...state.draft, ...action.payload };
			} else {
				state.draft = action.payload;
			}
		},
		setMeditationLoading: (state, action) => {
			state.loading = action.payload; 
		},
		removeMeditationsItem: (state, action) => {
			state.list = state.list.filter((item) => action.payload !== item.id);
		},
		updateMeditationItem: (state, action) => {
			const index = state.list.findIndex(item => item.id === action.payload.id);
			if (index !== -1) {
				state.list.splice(index, 1, action.payload);
			}
		}
	},
});

export const { setMeditationsList, addMeditationsItem, removeMeditationsItem, updateMeditationItem, setMeditationDraft, setMeditationLoading } = meditationsSlice.actions;

export const fetchMeditationsList = () => async (dispatch) => {

	try {

		const res = await api.meditationsList();
		dispatch(setMeditationsList(res.list));

	} catch (error) {

		throw error;
			
	}
};

export const updateMeditation = (meditation) => async (dispatch) => {

	dispatch(setMeditationLoading(true));

	try {

		const res = await api.updateMeditation( meditation );

		if (res) {
			dispatch(reloadMeditation(meditation.id));
		}

	} catch (error) {

		console.error(error);

		dispatch(showErrorToast({
			description: i18n.t('toasts.failedUpdateMeditation')
		}));

		throw error;

	} finally {

		dispatch(setMeditationLoading(false));

	}

};

export const reloadMeditation = (meditationId) => async (dispatch) => {

	dispatch(setMeditationLoading(true));

	try {

		const course = await api.meditationById(meditationId);

		if (course) {
			dispatch(updateMeditationItem(course));
		}

	} catch (error) {

		console.error(error);

		dispatch(showErrorToast({
			description: i18n.t('toasts.failedUpdateMeditation')
		}));

		throw error;

	} finally {

		dispatch(setMeditationLoading(false));

	}

};

export const getMeditationById = (id) => ( dispatch, getState ) => {

	return new Promise(( resolve, reject ) => {

		const state = getState();

		const list = state.meditations.list;

		let item = list.find(item => item.id === id);

		if (item) {

			resolve(item);

		} else {

			api.meditationById(id)
				.then(res => {
					dispatch(addMeditationsItem(res));
					resolve(res);
				})
				.catch(() => {

					dispatch(showErrorToast({
						description: i18n.t('toasts.lectureNotFound', { id })
					}));

					reject();

				});
		}

	});

};

export default meditationsSlice.reducer;
